import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    Contact,
    CustomerRiskScore,
    ContactCRMInfo,
    ContactAqAttempt,
} from '../models';
import { CrudBaseService } from '../crud.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ContactService extends CrudBaseService<Contact> {
    constructor(httpClient: HttpClient) {
        super('/contact', httpClient);
    }

    aqAttempt(
        contactId: string,
        attempts: ContactAqAttempt[]
    ): Observable<any> {
        return this.httpClient
            .post(`${this.basePath}/${contactId}/aq_attempt`, {
                data: attempts,
            })
            .pipe(map((res: any) => res && res.data));
    }
    aqTotal(
        contactId: string,
        aqTotalData: {
            trading_experience_score: number;
            appropriateness_quiz_score?: number;
        }
    ): Observable<any> {
        return this.httpClient
            .post(`${this.basePath}/${contactId}/aq_totals`, {
                data: aqTotalData,
            })
            .pipe(map((res: any) => res && res.data));
    }

    verify(contactId: string): Observable<any> {
        return this.httpClient
            .post(`${this.basePath}/${contactId}/verify`, {})
            .pipe(map((res: any) => res && res.data));
    }

    calculateRiskScore(
        contactId: string,
        tenant: string
    ): Observable<{ grade: CustomerRiskScore }> {
        return this.httpClient
            .get(`${this.basePath}/${contactId}/risk_score/${tenant}`)
            .pipe(map((res: any) => res && res.data));
    }

    /**
     * Retrieves all crm_ids related to this DVContact.
     *
     * @param contactId ID of a contact
     */
    getCrmInfo(contactId: string): Observable<ContactCRMInfo> {
        return this.httpClient
            .get(`${this.basePath}/${contactId}/crm_get`)
            .pipe(map((res: any) => res && (res.data as ContactCRMInfo)));
    }

    reSync(contactId: string): Observable<{ crm_id: string }> {
        return this.httpClient
            .get(`${this.basePath}/${contactId}/crm_update`)
            .pipe(map((res: any) => res && (res.data as { crm_id: string })));
    }
}
